"use client";

import React from "react";
import { Box } from "@mui/material";

/**
 * Circular play button component for video overlays
 * Features a circular white border with semi-transparent background
 */
export const CircularPlayButton = () => (
  <Box
    data-testid="circular-play-button"
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "72px",
      height: "72px",
      borderRadius: "50%",
      border: "3px solid rgba(255, 255, 255, 0.9)",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2,
      pointerEvents: "none"
    }}
  >
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      aria-hidden="true"
      style={{ marginLeft: "4px" }}
    >
      <path
        d="M22.5 12.268C23.8333 13.0378 23.8333 14.9623 22.5 15.732L3 27.0933C1.66667 27.8631 0 26.9008 0 25.3612L0 2.63878C0 1.09918 1.66667 0.136928 3 0.906728L22.5 12.268Z"
        fill="white"
      />
    </svg>
  </Box>
);
